import { CheckBox, Typography } from "components/atoms";
import { ChoiceType } from "utils/types/OnboardingForms";

interface IProps {
  options: ChoiceType[] | undefined;
  value: string;
  onChange: (e: any) => void;
}

export const MultipleCheckbox = ({ options, value, onChange }: IProps) => {
  return (
    <div className="check-items-wrapper">
      {options &&
        options.map((option: ChoiceType, index: number) => (
          <div className="check-wrapper" key={index}>
            <CheckBox
              checked={
                value &&
                Array.isArray(value) &&
                value.find((val: string) => val === option.Value)
              }
              onChange={() => onChange(option)}
            />
            <Typography
              label={option.Label}
              variant="h7Bold"
              styles="check-label-custom-style"
            />
          </div>
        ))}
    </div>
  );
};
